import React, { memo, useRef } from 'react';
import { Modal, Button, Row, Col, Form } from 'react-bootstrap';
import { useClickAway } from 'react-use';
import ModalHeader from '../partials/modalHeader';

const AddAttachment = ({
  title,
  setTitle,
  files,
  setFiles,
  isAttachmentModal,
  setIsAttachmentModal,
}) => {
  const ref = useRef(null);
  useClickAway(ref, () => {
    setIsAttachmentModal(false);
  });

  return (
    <Modal
      show={isAttachmentModal}
      size="md"
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <ModalHeader title={'Attachments'} action={setIsAttachmentModal} />
      <Modal.Body className="pb-3" ref={ref}>
        <Form>
          <Row>
            <Col>
              <Form.Group className="mb-3" controlId="name">
                <Form.Label>Title</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter title here"
                  defaultValue={title}
                  onChange={(e) => setTitle(e.target.value)}
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="files">
                <Form.Label>Files</Form.Label>
                <Form.Control
                  className="form-control"
                  type="file"
                  title={!title ? 'Enter title first' : ''}
                  disabled={!title}
                  accept="image/*,application/pdf"
                  multiple
                  onChange={(e) =>
                    setFiles((prev) => [
                      ...prev,
                      ...Array.from(e.target.files),
                    ])
                  }
                  onClick={(e) => (e.target.value = null)}
                />
              </Form.Group>
              {files?.length > 0 && (
                <div className="mb-3">
                  {files.map((f, i) => (
                    <div
                      key={i}
                      className="d-flex align-items-center justify-content-between mb-1 px-2 py-1 border rounded"
                      style={{ fontSize: '13px' }}
                    >
                      <span>
                        <i
                          className={`far fa-file-${
                            f.type === 'application/pdf' ? 'pdf' : 'image'
                          } mr-2`}
                        />
                        {f.name}
                      </span>
                      <i
                        className="far fa-times-circle cursor-pointer ml-2 text-danger"
                        onClick={() =>
                          setFiles(files.filter((_, idx) => idx !== i))
                        }
                      />
                    </div>
                  ))}
                </div>
              )}
            </Col>
          </Row>
        </Form>
        <Row>
          <Col className="text-center">
            <Button
              variant="primary"
              size="sm"
              onClick={() => setIsAttachmentModal(false)}
            >
              OK
            </Button>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
};
export default memo(AddAttachment);
